<template>
    <div class="container mescroll-touch">
        <img src="../../assets/images/ccdscontacttop.png" class="img" />
        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/ccdscontacticon.png" class="modeltitleimg" />
                    <div class="modeltitletext">征文投稿</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">陈淑君 13916116815</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/ccdscontacticon.png" class="modeltitleimg" />
                    <div class="modeltitletext">嘉宾组</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">陈淑君 13916116815</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/ccdscontacticon.png" class="modeltitleimg" />
                    <div class="modeltitletext">注册组</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">舒春蕾 18816510283</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/ccdscontacticon.png" class="modeltitleimg" />
                    <div class="modeltitletext">展商合作</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">郑德超 15800904667</div>
            </div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/ccdscontacticon.png" class="modeltitleimg" />
                    <div class="modeltitletext">会务组</div>
                </div>
            </div>
            <div class="neirong">
                <div class="name">张&nbsp;&nbsp;&nbsp;&nbsp;怡 13818361467</div>
            </div>
        </div>
        <floatback />
    </div>
</template>

<script>
import floatback from './floatback.vue';
import mixin from '../../common/mixin/mixins'
export default {
    name: 'ccdscontact',
    data() {
        return {
        }
    },
    mixins: [mixin],
    components: {
        floatback
    },
    created() {
        this.initccdsShare();
        document.title = "CCDS第四届中国皮肤外科大会";
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.zuzhititleimg {
    display: block;
    width: 55%;
    margin: auto;
    margin-bottom: .2rem
}

.zuzhititleimg1 {
    display: block;
    width: 55%;
    margin: .5rem auto .2rem auto;
}

.guanggaoimg {
    display: block;
    width: 92%;
    margin: 0.5rem auto;
}

.modelline {
    border-bottom: 1px solid rgb(0, 53, 133);
    border-bottom-left-radius: 50rem;
}

.modeltitle {
    background: rgb(0, 53, 133);
    width: 37%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitleimg {
    display: block;
    width: 15%;
    background: #fff;
    border-radius: 50rem;
    width: 0.5rem;
    height: 0.5rem;
    box-sizing: border-box;
    padding: 0.05rem;
}

.modeltitletext {
    margin-left: 0.2rem;
    color: #fff;
    font-weight: bold;
    // font-size: 16px;
}

.model {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
}

.model1 {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
    padding-bottom: .3rem;
}

.center {
    text-align: center;
}

.preple {
    color: rgb(0, 53, 133);
}

.neirong {
    margin-top: .3rem
}

.ziti {
    font-size: .37rem;
}

.neirong {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 95%;
    margin: 0.1rem auto;
}

.name {
    // width: 14.28%;
    text-align: center;
    font-size: .35rem;
    margin: 0.1rem 0;
}

.footer {
    width: 92%;
    margin: auto;
    margin-bottom: 0.5rem;
    text-align: right;
    font-size: .3rem;
    border-bottom: 0.5rem solid rgb(0, 53, 133);
    font-weight: bold;
}
</style>